import { ColumnDetails } from '../../grid/types/common';
import { defaultLabelRenderer, gridCustomHtmlRenderer } from '../../grid/utils/renderers';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import { ColumnKeys } from '@nirvana/shared/dtos/types/alerts/common';
import { getLabelForEnumValue } from '../../grid/utils/columns';
import { Target } from '@nirvana/shared/company-helper/nestjs';
import { isEmpty } from '@nirvana/shared/basic-types/object';

export function categoryRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];
  const label = getLabelForEnumValue(columnDetails, cellValue);

  return gridCustomHtmlRenderer(
    `
      <span class="cell-label">${label}</span>`
  );
}

export function lastDetectedHeaderRenderer(columnName: string): string {
  return `<span class="text-semibold cell-label">${columnName}
            <span class="sorting-icon ds-icon ds-icon-sorting_up"></span>
    </span>`;
}

export function companyRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const target: Target = rowData.item[columnDetails.key];
  const label = isEmpty(target.companyName) ? '-' : target.companyName;

  return defaultLabelRenderer(label);
}
